import { groupActions } from '../../../actions/medichat/groups/groups';

const initialState = {
  loading: false,
  error: null,
  groups: []
};

const groupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case groupActions.FETCH_GROUPS.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case groupActions.FETCH_GROUPS.SUCCESS:
      return {
        ...state,
        loading: false,
        groups: action.payload
      };
    case groupActions.FETCH_GROUPS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case groupActions.CREATE_GROUP.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case groupActions.CREATE_GROUP.SUCCESS:
      return {
        ...state,
        loading: false,
        groups: state.groups ? [action.payload, ...state.groups] : [action.payload]
      };
    case groupActions.CREATE_GROUP.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
};
export default groupsReducer;
